<template>
  <div>
    <MasterLayout>
      <div class="p-4 dashboard_first_row">
        <div class="row align-items-center">
          <div class="col-md-1 remove-right-padding text-center">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bill (1).svg" width="25" />
            </div>
          </div>
          <div class="col-md-10">
            <h4 class="primary-color font-600">
              {{ company.name }} {{ $t("text.cInvoice.breakdown.title") }}
            </h4>
            <p class="light-grey-text mt-3">
              {{ $t("text.cInvoice.breakdown.desc1") }} <br />
              {{ $t("text.cInvoice.breakdown.desc2") }}
            </p>
          </div>
        </div>
        <div class="dialog-container invoices_home">
          <div class="invoice-banner mt-3">
            <div>
              <div>
                <span class="font-500 text-black invoice-header">
                  {{ $t("text.cInvoice.breakdown.totalAmount") }}:</span
                >
              </div>
              <div class="mt-2">
                <span
                  ><span class="currency"></span
                  ><span class="amount-figures primary-color">{{
                    convertThousand(totalAmount)
                  }}</span
                  ><span class="bold-span primary-color">{{
                    company ? company.currency : ""
                  }}</span></span
                >
              </div>
              <div class="mt-2">
                <span class="font-500 text-black invoice-header">{{
                  $t("text.cInvoice.breakdown.monthly")
                }}</span>
              </div>
            </div>
            <div>
              <button
                class="ep-btn ep-primary"
                @click="setupPayment"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.cInvoice.setupPayment") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </div>
        </div>
        <h6 class="primary-color mt-3">
          {{ $t("text.cInvoice.breakdown.subList") }}
        </h6>
        <div class="position-relative mt-3">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="true"
            :allowSorting="false"
            :allowExcelExport="false"
            :allowPdfExport="false"
            :toolbarClick="toolbarClick"
            :allowTextWrap="true"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                width="150"
                field="dateAdded"
                :format="formatOptions"
                type="date"
                :headerText="$t('text.cInvoice.date')"
              ></e-column>
              <e-column
                width="200"
                field="branchName"
                :headerText="$t('text.cInvoice.station')"
              ></e-column>
              <e-column
                width="200"
                field="amount"
                :headerText="$t('text.cInvoice.details.amount')"
                format="N2"
                textAlign="right"
              ></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
          <div class="mt-3" style="margin: 0 auto">
            <!-- <Paginator 
                            v-show="!showLoader"
                            :total-pages="totalPages"
                            :per-page="pageSize"
                            :current-page="currentPage"
                            @pagechanged="onPageChange"
                            @getPageSize="getPageSize"
                            :pageSize="pageSize"
                        /> -->
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  groupAggregates,
} from "@syncfusion/ej2-vue-grids";
import Temp from "@/components/Templates/invoices";
import DateTemp from "@/components/Templates/dateTemp";
import Paginator from "@/components/Paginator.vue";
import invoiceTemp from "@/components/Templates/list_of_invoices_template.vue";
import VueMomentsAgo from "vue-moments-ago";
import RecurringPaymentTemplate from "@/components/Templates/recurringPaymentTemplate.vue";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Recurring Breakdown:: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    VueMomentsAgo,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      companyId: null,
      isButtonDisabled: false,
      showLoader: false,
      dateAdded: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      company: null,
      totalAmount: 0,
      subscriptionDetails: null,
      template: function () {
        return {
          template: RecurringPaymentTemplate,
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
  },
  mounted() {
    // const company = localStorage.getItem("companyDetails")
    //   ? JSON.parse(localStorage.getItem("companyDetails"))
    //   : null;

    this.subscriptionId = this.$route.query.subscriptionId;
    let ml = sessionStorage.getItem(this.subscriptionId);
    if (!ml) {
      let allData = localStorage.getItem("subscriptionBreakdownList");
      let dt = JSON.parse(allData);
      dt.forEach((my, index) => {
        if (my.id === this.subscriptionId) {
          ml = JSON.stringify(my);
          sessionStorage.setItem(this.subscriptionId, ml);
        }
      });
    }

    let subscriptionDetails = JSON.parse(ml);
    this.dateAdded = subscriptionDetails.dateAdded;
    this.subscriptionDetails = subscriptionDetails;
    this.totalAmount = this.subscriptionDetails.subscriptionItems.reduce(
      (acc, cur) => (acc += cur.amount),
      0
    );
    this.subscriptionDetails.subscriptionItems.forEach((el) => {
      el.dateAdded = this.dateAdded;
    });
    this.$refs.dataGrid.ej2Instances.setProperties({
      dataSource: this.subscriptionDetails.subscriptionItems,
    });
    this.refreshGrid();
  },
  methods: {
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setupPayment() {
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/DDSubscription/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.totalAmount}`,
          {},
          configObject.authConfig()
        )
        .then((res) => {
          location.href = res.data;
          // this.$router.push({name: 'recurring-payment-status'})
          this.isButtonDisabled = false;
          $(".loader").hide();
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.statusDescription,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.showLoader = false;
        });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "branches.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>
